import { getCustomerNameBySearch } from '@/modules/mdm/api/customer/customerManage.js';
import { idNumber, noChineseReg } from '@/modules/mdm/utils/regList.js';

export const tableConfig = {
    name: 'addCustomer',
    fields: [
        {
            label: '客户控制类型',
            prop: 'customerBodyType',
            labelWidth: '120px',
            type: 'custom',
            visible: true,
            disabled: true,
            rule: [
                { required: true, message: '客户控制类型不能为空', trigger: ['change', 'blur'] }
            ],
            optionsKey: 'SYS_RELATION_LEVEL'
        },
        {
            label: '内外渠',
            prop: 'customerChannel',
            type: 'select',
            visible: true,
            rule: [
                { required: true, message: '内外渠不能为空', trigger: ['change', 'blur'] }
            ],
            optionsKey: 'LMDM_CUSTOMER_CHANNEL'
        },
        {
            label: '内外销客户', // 占位
            prop: 'isImpExpCustomer',
            type: 'select',
            visible: true,
            rule: [
                { required: true, message: '内外销客户不能为空', trigger: ['change', 'blur'] }
            ],
            optionsKey: 'IS_IMP_EXP_CUSTOMER'
        },
        {
            label: '客户名称',
            prop: 'customerName',
            labelWidth: '120px',
            rule: [
                { required: true, message: '客户名称不能为空', trigger: ['change', 'blur'] }
            ],
            maxlength: 200,
            type: 'custom'
        },
        {
            label: '英文名称',
            prop: 'ebcuNameEn',
            labelWidth: '120px',
            visible: false,
            rule: [
                { required: true, message: '英文名称不能为空', trigger: ['change', 'blur'] },
                {
                    pattern: noChineseReg,
                    message: '英文名称格式不对',
                    trigger: 'blur'
                }
            ],
            maxlength: 200,
            type: 'input'
        },
        {
            label: '社会信用代码',
            prop: 'societyCreditCode',
            labelWidth: '120px',
            rule: [
                { required: true, message: '社会信用代码不能为空', trigger: ['change', 'blur'] }
            ],
            type: 'custom'
        },
        {
            label: '法人代表',
            prop: 'ebcuLegalEntity',
            type: 'input'
        },
        {
            label: '营业执照号',
            prop: 'ebcuBusinessNo',
            type: 'input'
        },
        {
            label: '组织机构代码',
            prop: 'ebcuOrgBarcode',
            type: 'input'
        },
        {
            label: '身份证',
            prop: 'idNumber',
            type: 'input',
            rule: [
                { required: true, message: '身份证不能为空', trigger: ['change', 'blur'] },
                {
                    pattern: idNumber,
                    message: '身份证格式不对',
                    trigger: 'blur'
                }
            ]
        },
        {
            label: '中信保编码',
            prop: 'sinosureCode',
            type: 'input',
            visible: false
        }

    ],
    height: 325
};

export const customerGroupConfig = {
    name: '客户名称',
    value: 'customerName',
    type: 'advance',
    isFixed: true,
    span: 3,
    advanceConfig: [
        { prop: 'customerName', value: '客户名称' },
        { prop: 'customerUnitCode', value: '集团编码' }
    ],
    tableConfig: [
        { prop: 'customerUnitCode', value: '集团编码' },
        { prop: 'customerName', value: '客户名称' }
    ],
    prefix: '/api-lcrm',
    method: 'post',
    advanceUrl: '/gcrm/customer/query',
    cbParams: ['innerCustFlag', 'customerUnitCode#originalGroupCode', 'customerName#customerName', 'taxpayerTypeLmdm#ebcuTaxpayersType', 'enterpriseNature#ebcuPlatformNature',
        'uscc#societyCreditCode', 'corpRepresentative#ebcuLegalEntity', 'registrationNumber#ebcuBusinessNo', 'nacao#ebcuOrgBarcode'
    ],
    advanceCode: 'advanceCode',
    beforeRequest: (params) => {
        // params.innerCustFlag = 'Y';
        return params;
    }
};

export const inputConfig = {
    apiUrl: getCustomerNameBySearch,
    // isRequest: (params) => { // 判断条件是否需要联想查询
    //     return params.length < 2;
    // },
    beforeRequest: (params) => {
        params.validityPeriod = 10; // 默认10天, 命中取缓存 不设置则调用接口,收费
        return params;
    },
    afterResponse: res => {
        if (res && +res.code === 0) {
            res.data.forEach(it => {
                it.name = it.customerName;
            });
        }
        return res;
    }
};
